import React, { PureComponent } from 'react';

class CabeceraGrilla extends PureComponent {
    constructor(props) {
        super(props);

        this.cambiarOrden = this.cambiarOrden.bind(this);
    }

    cambiarOrden(columna, valor) {
        this.props.cambiarOrden(columna, valor);
    }

    render() {
        const { 
            ordenGrilla, 
            columnaActivaOrdenamiento
        } = this.props;

        return (
            <div className="seccionGrilla__registroCabecera">
                <div className={"seccionGrilla__registroCabecera__Codigo" + (columnaActivaOrdenamiento == 'codigo' ? " seccionGrilla__registroCabecera--columnaActiva" : "")} onClick={() => this.cambiarOrden("codigo", !ordenGrilla.codigo)}>
                    CÓDIGO 
                    <span 
                        className={"seccionGrilla__registroCabeceraTrianguloUp" + (columnaActivaOrdenamiento == 'codigo' ? " seccionGrilla__registroCabeceraTrianguloUpActivo" : "") + (ordenGrilla.codigo ? "" : " seccionGrilla__registroCabeceraTrianguloUp--descendente")}>
                    </span>
                </div>

                <div className={"seccionGrilla__registroCabecera__Descripcion" + (columnaActivaOrdenamiento == 'descripcion' ? " seccionGrilla__registroCabecera--columnaActiva" : "")} onClick={() => this.cambiarOrden("descripcion", !ordenGrilla.descripcion)}>
                    DESCRIPCIÓN 
                    <span 
                        className={"seccionGrilla__registroCabeceraTrianguloUp" + (columnaActivaOrdenamiento == 'descripcion' ? " seccionGrilla__registroCabeceraTrianguloUpActivo" : "") + (ordenGrilla.descripcion ? "" : " seccionGrilla__registroCabeceraTrianguloUp--descendente")}>
                    </span>
                </div>

                <div className={"seccionGrilla__registroCabecera__Marca" + (columnaActivaOrdenamiento == 'marca' ? " seccionGrilla__registroCabecera--columnaActiva" : "")} onClick={() => this.cambiarOrden("marca", !ordenGrilla.marca)}>
                    MARCA 
                    <span 
                        className={"seccionGrilla__registroCabeceraTrianguloUp" + (columnaActivaOrdenamiento == 'marca' ? " seccionGrilla__registroCabeceraTrianguloUpActivo" : "") + (ordenGrilla.marca ? "" : " seccionGrilla__registroCabeceraTrianguloUp--descendente")}>
                    </span>
                </div>

                <div className={"seccionGrilla__registroCabecera__TipoMovimiento" + (columnaActivaOrdenamiento == 'tipoMovimiento' ? " seccionGrilla__registroCabecera--columnaActiva" : "")} onClick={() => this.cambiarOrden("tipoMovimiento", !ordenGrilla.tipoMovimiento)}>
                    TIPO MOVIMIENTO 
                    <span 
                        className={"seccionGrilla__registroCabeceraTrianguloUp" + (columnaActivaOrdenamiento == 'tipoMovimiento' ? " seccionGrilla__registroCabeceraTrianguloUpActivo" : "") + (ordenGrilla.tipoMovimiento ? "" : " seccionGrilla__registroCabeceraTrianguloUp--descendente")}>
                    </span>
                </div>

                <div className="seccionGrilla__registroCabecera__Inactivo">
                </div>
            </div>
        )
    }
}

export default CabeceraGrilla;